import enUS from '@arco-design/web-vue/es/locale/lang/en-us'
import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn'
import type { ArcoLang } from '@arco-design/web-vue/es/locale/interface'
import { get } from 'lodash-es'
import { i18n } from '@/plugins/i18n'

export default function useArcoLang() {
  const currentLocale = computed(() => i18n.global.locale.value)
  const localMap: Record<'zh-CN' | 'en-US', ArcoLang> = {
    'zh-CN': zhCN,
    'en-US': enUS,
  }

  const locale = computed(() => get(localMap, currentLocale.value, enUS))

  return {
    locale,
    currentLocale,
  }
}
